<template>
    <Dimmer
        class="product-filters"
        :hide-spinner="true"
        :model-value="progress"
    >
        <template #content>
            <!-- Records Available -->
            <div
                v-if="!lo_isError(filters) && filters?.length && filtersModel"
                class="product-filter-container d-flex flex-column px-4 pb-4"
            >
                <template
                    v-for="filter in filters"
                    :key="`filter-${filter.uid}`"
                >
                    <ProductsFilterColors
                        v-if="filter.values?.length && filter.name === 'Color'"
                        v-model="filtersModel[filter.uid!]"
                        :items="filter"
                        @update:model-value="onUpdate"
                    ></ProductsFilterColors>
                    <ProductsFilterCheckboxes
                        v-else-if="filter.values?.length"
                        v-model="filtersModel[filter.uid!]"
                        :items="filter"
                        @update:model-value="onUpdate"
                    ></ProductsFilterCheckboxes>
                </template>
            </div>
            <!-- Loading / No Records / Error -->
            <div
                v-else
                class="product-filter-info-box py-0 px-6 font-size-8 rounded"
            >
                <div
                    v-if="!lo_isError(filters) && filters?.length === 0"
                    class="py-6"
                >
                    No Filters Available
                </div>
                <div
                    v-else-if="lo_isError(filters)"
                    class="py-6 text-red d-flex line-height-3 align-center"
                >
                    <v-icon
                        color="error"
                        class="col-md-3 col-1"
                        :icon="mdiAlert"
                    ></v-icon>
                    Could not load options. Reload page to try again.
                </div>
                <div
                    v-else
                    class="py-6"
                >
                    <v-progress-circular
                        size="24"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    <span
                        class="d-inline-block ml-4 text-overline"
                    >
                        Loading Filters...
                    </span>
                </div>
            </div>
        </template>
    </Dimmer>
</template>

<script lang="ts" setup>
    import ProductsFilterCheckboxes from '~/components/products/products-list/ProductsFilterCheckboxes/ProductsFilterCheckboxes.vue';
    import ProductsFilterColors from '~/components/products/products-list/ProductsFilterColors/ProductsFilterColors.vue';
    import { isError as lo_isError } from 'es-toolkit';
    import Dimmer from '~/components/Dimmer/Dimmer.vue';
    import type {
        ProductFilterAttribute,
        ProductFilterModel
    } from '~/types';
    import { mdiAlert } from '@mdi/js';

    const props = defineProps<{
        filters: Nilish<ProductFilterAttribute[] | Error>;
        filtersModel: Nullable<ProductFilterModel>;
        resourcePath: string;
        productsLoading: boolean;
        productsPaging: boolean;
    }>();

    const emit = defineEmits<{
        'on-update': [value: void];
    }>();

    const progress = computed<boolean>(() => props.productsLoading || props.productsPaging);

    function onUpdate() {
        emit('on-update');
    }
</script>

<style lang="scss">
.product-filter-container {
    gap: 1rem;
}

.product-filter-info-box {
    background-color: rgb(var(--v-theme-surface-light));
}
</style>
